import NuvemAppPage from 'domains/PartnersApps/pages/NuvemAppPage';
import { useNuvemApps } from 'domains/PartnersApps/pages/NuvemAppPage/hooks';
import { NuvemChatPage } from './pages/NuvemChatPage';

function NuvemChat() {
  const { nuvemApps } = useNuvemApps();

  return nuvemApps.nuvemchat ? (
    <NuvemAppPage code="nuvemchat" />
  ) : (
    <NuvemChatPage />
  );
}

export default NuvemChat;
